/**
 * `useAuthRequired` —— 对齐 App 守卫语义(_shared C-1):
 * 受守卫动作(下单/发布/消息等)在无有效会话时跳登录,并记住来源,登录后回跳。
 * 返回一个 guard 函数:已登录则执行 action,未登录则导航到 /login(带 from)。
 */
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';

export function useAuthRequired(): (action?: () => void) => boolean {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  return useCallback(
    (action?: () => void) => {
      if (isAuthenticated()) {
        action?.();
        return true;
      }
      navigate('/login', { state: { from: location.pathname + location.search } });
      return false;
    },
    [isAuthenticated, navigate, location],
  );
}
